import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/stores/authStore";
import { UpgradeModal } from "./UpgradeModal";

export function LimitReachedCard() {
  const { t } = useTranslation();
  const tier = useAuthStore((s) => s.user?.tier ?? "free");
  const [dismissed, setDismissed] = useState(false);
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  const isFree = !tier || tier === "free";

  return (
    <>
      <div className="cx-limit-card" role="alert">
        <p className="cx-limit-card-title">
          {t(isFree ? "upgrade.limitReachedTitle" : "upgrade.limitReachedTitlePro")}
        </p>
        <p className="cx-limit-card-pitch">
          {t(isFree ? "upgrade.pitchPro.lead" : "upgrade.pitchMax.lead")}
        </p>
        <p className="cx-limit-card-detail">
          {t(isFree ? "upgrade.pitchPro.detail" : "upgrade.pitchMax.detail")}
        </p>
        <p className="cx-limit-card-reset">{t("upgrade.resetsAt")}</p>

        {!dismissed ? (
          <div className="cx-limit-card-actions">
            <button
              className="cx-limit-card-btn cx-limit-card-btn--primary"
              onClick={() => setUpgradeOpen(true)}
            >
              {t("upgrade.upgrade")}
            </button>
            <button
              className="cx-limit-card-btn cx-limit-card-btn--secondary"
              onClick={() => setDismissed(true)}
            >
              {t("upgrade.notNow")}
            </button>
          </div>
        ) : (
          <p className="cx-limit-card-dismissed">{t("upgrade.dismissed")}</p>
        )}
      </div>
      <UpgradeModal open={upgradeOpen} onClose={() => setUpgradeOpen(false)} />
    </>
  );
}
